export const DialogAssetsColumn = [
    {
        id: "nameWithSubName",
        label: "Name",
        style: { paddingLeft: "12px", flex: 1 },
    },
];

export default DialogAssetsColumn;
